<template>
  <div :class="`article-overall${receiveProps.blockInstanceId}`" ref="articleContainRefs" :style="articleContainStyl">
    <TitleBar :titleData="receiveProps"/>
    <component :is="componentTemp" :receiveProps="receiveProps"/>  
    <!-- <div id="mount-point"></div> -->
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'graphicCombination',
  props:{
    receiveProps:{
      type: [Object, Array],
      default: ()=>{}
    }
  },
  components:{
    TitleBar: ()=>import('./componentArticle/ArticleTitleBar')
  },
  data(){
    return {
      moduleType: 'articleLR-thr',
      componentTemp: ()=>import('./componentArticle/articleLR-one'),
      isBanner: true, // 通栏为true  分栏为false
      publishStyl: this.receiveProps.tempData.specialStyle
    }
  },
  mounted(){
    this.changeModularFn()
     let classArr = this.$refs.articleContainRefs.parentNode.classList
    for(var i=0;i<classArr.length;i++){ //获取父节点  el-col-24  el-col-12
        if(classArr[i]=='el-col-12'){
          this.isBanner = false
        } 
      }
      this.receiveProps.isBanner = this.isBanner
  },
  methods:{
    changeModularFn(){
      let {templateType, isCustTemplate, custTemplate, templateName} = this.receiveProps.tempData.specialData  // 模板组合
      const activeUrl = {
        1: 'articleLR-one',
        2: 'articleLR-two',
        3: 'articleLR-thr',
        4: 'articleTB-two',
        5: 'articleTB-thr',
        6: 'articleTB-four',
        7: 'articleTB-five',
        8: 'articleTB-six',
        9: 'articleAdaptiveOne',
        10: 'articleRL-one',
        11: 'articleRL-two',
        12: 'articleRL-thr',
      }
      // if (Number(templateType)) {
      //   if (Object.prototype.hasOwnProperty.call(activeUrl, templateType)){
      //     import(`./componentArticle/${activeUrl[templateType]}`).then((module) => {
      //       this.componentTemp = module.default

      //       if (isCustTemplate == 'true') {
      //         delete this.componentTemp.render
      //         this.componentTemp.template = custTemplate
      //       }
      //       let Profile = Vue.extend(this.componentTemp)
      //       new Profile({
      //         propsData: {
      //           receiveProps: this.receiveProps
      //         }
      //       }).$mount('#mount-point')
      //     })
      //   } else {
      //     import(`./componentArticle/${templateName}`).then((module) => {
      //       this.componentTemp = module.default

      //       if (isCustTemplate == 'true') {
      //         delete this.componentTemp.render
      //         this.componentTemp.template = custTemplate
      //       }
      //       let Profile = Vue.extend(this.componentTemp)
      //       new Profile({
      //         propsData: {
      //           receiveProps: this.receiveProps
      //         }
      //       }).$mount('#mount-point')
      //     })
      //   }
      // }
      Number(templateType)&&(this.componentTemp = ()=>import(`./componentArticle/${activeUrl[templateType]}`)) //判断是否存在templateType
    }
  },
  computed:{
    articleContainStyl() {
      let {blockMargeTop, blockMargeBottom, blockBGClolor} = this.publishStyl
      return {
        margin: '0 auto',
        // padding: '0 24px',
        boxSizing: 'border-box',
        marginTop: `${blockMargeTop}px`,
        marginBottom: `${blockMargeBottom}px`,
        backgroundColor: blockBGClolor,
        maxWidth: this.isBanner? '1200px': '600px'
      };
    },
  }

}
</script>

<style lang="less" scoped>
// .article-overall{
  // margin: 0 auto;
  // padding: 24px;
  // box-sizing: border-box;
// }

</style>